import React from "react";
import { useFela } from "react-fela";

import { Grid } from "@/components/Grid";
import { useTheme } from "@/hooks/useTheme";
import { Image } from "@/components/Image";
import { Heading } from "@/components/Heading";

import { IToolsVisualizationSection } from "./types";

type IProps = IToolsVisualizationSection & JSX.IntrinsicElements["div"];

export const ToolsVisualizationSection: React.FC<IProps> = ({
  title,
  imageAlt,
  ...rest
}) => {
  const { css } = useFela();
  const { bp } = useTheme();

  return (
    <Grid
      customStyle={{
        flexDirection: "column",
        alignItems: "center",
      }}
      id="ToolsVisualizationSection"
      {...rest}
    >
      <div
        className={css({
          marginBottom: 40,
          textAlign: "center",
          [bp.FROM_DESKTOP]: {
            marginBottom: 60,
          },
        })}
      >
        <Heading as="h2">{title}</Heading>
      </div>

      <Image
        src="/svgs/converter-illustration.svg"
        alt={imageAlt}
        customStyle={{ maxWidth: "100%" }}
      />
    </Grid>
  );
};
